/** Save to localStorage (primary) and a cookie (backup) */
function save(gclid: string) {
  try {
    localStorage.setItem("gclid", gclid);
    localStorage.setItem("gclid_ts", String(Date.now()));
  } catch (e) {
    // localStorage might be blocked (Safari Private Mode, etc.)
    if (
      typeof console !== "undefined" &&
      process.env.NODE_ENV !== "production"
    ) {
      console.debug("localStorage unavailable:", e);
    }
  }
  const expires = new Date(Date.now() + 90 * 24 * 60 * 60 * 1000).toUTCString();
  document.cookie = `gclid=${encodeURIComponent(gclid)}; expires=${expires}; path=/; samesite=lax; secure`;
}

/** Call once on first page load: captures gclid from URL and stores it. */
export function captureGclidFromUrl(): void {
  const p = new URLSearchParams(window.location.search);
  const gclid = p.get("gclid");
  if (!gclid) return;
  save(gclid);
}

/** Read stored gclid right before you call your payment endpoint. */
export function getGclid(): string | null {
  try {
    const v = localStorage.getItem("gclid");
    const ts = localStorage.getItem("gclid_ts");
    if (v && ts && Date.now() - Number(ts) <= 90 * 24 * 60 * 60 * 1000) {
      return v;
    }
  } catch (e) {
    // localStorage can be blocked (Safari Private / strict settings)
    if (
      typeof console !== "undefined" &&
      process.env.NODE_ENV !== "production"
    ) {
      console.debug("localStorage read failed:", e);
    }
  }
  // Fallback if LS unavailable/cleared
  const m = document.cookie.match(/(?:^|; )gclid=([^;]+)/);
  return m ? decodeURIComponent(m[1]) : null;
}
